import React from 'react';
import { Logo } from './Logo';
import { useBooking } from './BookingContext';
export function Footer() {
  const {
    openBooking
  } = useBooking();
  return <footer className="bg-[#050505] border-t border-white/5 py-16 relative z-10" data-id="element-275">
      <div className="max-w-7xl mx-auto px-6" data-id="element-276">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-10 mb-16" data-id="element-277">
          <div data-id="element-278">
            <Logo className="text-2xl mb-4" dotClassName="w-2 h-2 ml-1" data-id="element-279" />
            <p className="text-sm text-gray-500 font-medium tracking-wide" data-id="element-280">
              Purpose-built AI for real industries.
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-x-8 gap-y-4" data-id="element-281">
            <a href="#solutions" className="text-sm font-medium text-gray-400 hover:text-white transition-colors" data-id="element-282">
              Solutions
            </a>
            <a href="#platform" className="text-sm font-medium text-gray-400 hover:text-white transition-colors" data-id="element-283">
              Platform
            </a>
            <a href="#solutions" className="text-sm font-medium text-gray-400 hover:text-white transition-colors" data-id="element-284">
              Industries
            </a>
            <a href="#about" className="text-sm font-medium text-gray-400 hover:text-white transition-colors" data-id="element-285">
              About
            </a>
            <a href="#contact" className="text-sm font-medium text-gray-400 hover:text-white transition-colors" data-id="element-286">
              Contact
            </a>
            <button onClick={openBooking} className="text-sm font-medium text-brand-orange hover:text-brand-deep-orange transition-colors" data-id="element-287">
              Book a Demo
            </button>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between pt-8 border-t border-white/5 text-xs text-gray-600" data-id="element-288">
          <div data-id="element-289">
            © {new Date().getFullYear()} Aijentik. All rights reserved.
          </div>
          <div className="flex items-center gap-6 mt-4 md:mt-0" data-id="element-290">
            <a href="#" className="hover:text-gray-400 transition-colors" data-id="element-291">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-gray-400 transition-colors" data-id="element-292">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}